import { USER_EVENTS } from '@sm/metrics';

type SmParams = {
  surveyId?: string;
  collectorId?: string;
  respondentId?: string;
  categoryId?: string;
  languageId?: string;
};

type BaseEventData = {
  surveyId: string;
  collectorId: string;
  respondentId: string;
  surveyCategoryId: string;
  languageId: string;
  app: string;
  urlPath: string;
};

enum PAGE_NAME {
  SURVEY_TAKEN = 'survey taken',
  ENTERPRISE_THANK_YOU = 'enterprise thank you',
  SURVEY_CLOSED = 'survey closed',
  SURVEY_THANKS = 'survey thanks',
}

enum END_PAGE_USER_EVENT {
  // Page Lifecycle Events
  PAGE_VIEW = 'page viewed',
  // Experiment Events
  EXPERIMENT_EVENT = 'experiment event',
}

enum CONSTANTS {
  APP = 'respweb',
}

enum OPTIONAL_MOBILE_PATHS_EVENTS {
  CREATE_CTA = 'optional paths v3 survey creator cta',
  CONTRIBUTE_CTA = 'optional paths v3 survey contribute cta',
  HEADER_CLICKED = 'optional paths v3 header clicked',
}

type TrackEventData = {
  eventName: USER_EVENTS;
  pageName: PAGE_NAME;
  amplitudeEvent?: END_PAGE_USER_EVENT;
  templateType: string;
  smParams?: SmParams;
};

type LogEventData = {
  message: string;
  countryCode?: string;
  countryRegion?: string;
  languageId?: string;
};

export type { SmParams, BaseEventData, TrackEventData, LogEventData };
export { CONSTANTS, PAGE_NAME, END_PAGE_USER_EVENT, USER_EVENTS, OPTIONAL_MOBILE_PATHS_EVENTS };
